module.exports = __webpack_public_path__ + "img/home-step-icon-1.49078d8a.png";